var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { transient, autoinject } from "aurelia-dependency-injection";
import { LookupClientService } from "../../../../services/lookups/lookup-client.service";
import { DataType, SourceType } from "../../../../models/queries/queries.models";
import { NotifyPropertyChangedBase, Reflection } from "../../../../utilities/reflection";
import * as Enumerable from "linq";
import { computedFrom } from "aurelia-framework";
import { BindingEngine } from "aurelia-binding";
import { I18N } from 'aurelia-i18n';
import { UnitOfWorkObserver } from "../../../../utilities/unit-of-work-observer";
import { NotificationType, NotificationClientService } from "../../../../services/basics/notification-client.service";
var ManageLookups = /** @class */ (function (_super) {
    __extends(ManageLookups, _super);
    function ManageLookups(lookupClientService, notificationClient, engine, i18N) {
        var _this = _super.call(this) || this;
        _this.lookupClientService = lookupClientService;
        _this.notificationClient = notificationClient;
        _this.engine = engine;
        _this.i18N = i18N;
        _this.tableMetaDataItems = [];
        _this._isSequenceSorting = true;
        return _this;
    }
    Object.defineProperty(ManageLookups.prototype, "isSequenceSorting", {
        get: function () {
            return this._isSequenceSorting;
        },
        set: function (value) {
            this._isSequenceSorting = value;
            this.refreshTables();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ManageLookups.prototype, "maxSequenceNumber", {
        get: function () {
            return this.tableMetaDataItems
                ? Enumerable.from(this.tableMetaDataItems.map(function (meta) { return meta.lookup ? meta.lookup.sequenceNumber : 0; })).max()
                : 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ManageLookups.prototype, "isSavable", {
        get: function () {
            return this.isSequenceSorting && this.unitOfWorkObserver && this.unitOfWorkObserver.hasChanges();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ManageLookups.prototype, "columns", {
        get: function () {
            return [{
                    name: "tableDisplayName",
                    isSortable: !this.isSequenceSorting,
                    sortOrder: 0,
                    isAscending: true,
                    columnOrder: 0,
                    dataType: DataType.Default,
                    title: this.i18N.tr('lookup-name-text'),
                }];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ManageLookups.prototype, "search", {
        get: function () {
            return this._search;
        },
        set: function (x) {
            this._search = x;
            this.refreshTables();
        },
        enumerable: false,
        configurable: true
    });
    ManageLookups.prototype.activate = function () {
        this.loadLookups();
    };
    ManageLookups.prototype.deactivate = function () {
        this.unitOfWorkObserver.dispose();
    };
    ManageLookups.prototype.loadLookups = function () {
        var _this = this;
        this.lookupClientService.getTableMetadata().then(function (response) {
            var e_1, _a;
            _this.tableMetaDataItems.splice(0, _this.tableMetaDataItems.length);
            try {
                for (var _b = __values(response.tableMetadatas), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    _this.tableMetaDataItems.push(item);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
            _this.refreshTables();
            if (_this.unitOfWorkObserver) {
                _this.unitOfWorkObserver.dispose();
            }
            _this.unitOfWorkObserver = UnitOfWorkObserver.getTrackingInstance(_this.engine, { lookupValues: _this.tableMetaDataItems });
        }).catch(function (ex) {
            console.error(ex);
        });
    };
    ManageLookups.prototype.refreshTables = function () {
        var _this = this;
        this.tables = {
            source: Enumerable.from(this.tableMetaDataItems)
                .where(function (x) { return x.tableName.indexOf(".") == -1; }) // remove tables from other schemas
                .where(function (x) { return !_this.search || x.tableDisplayName.toLowerCase().indexOf(_this.search.toLowerCase()) != -1; }).orderBy(function (x) { return x.tableDisplayName; }).toArray(),
            sourceType: SourceType.Collection,
            columns: this.columns
        };
    };
    ManageLookups.prototype.selectLookupValues = function (event) {
        this.currentTableMetaData = event.detail.item;
    };
    ManageLookups.prototype.moveUp = function (metadata) {
        if (!(metadata && !!metadata.lookup && metadata.lookup.sequenceNumber > 1)) {
            return;
        }
        this.tableMetaDataItems.filter(function (meta) { return meta.lookup.sequenceNumber == metadata.lookup.sequenceNumber - 1; }).forEach(function (meta) {
            meta.lookup.sequenceNumber++;
        });
        metadata.lookup.sequenceNumber--;
        this.refreshTables();
    };
    ManageLookups.prototype.moveDown = function (metadata) {
        if (!(metadata && !!metadata.lookup && metadata.lookup.sequenceNumber < this.maxSequenceNumber)) {
            return;
        }
        this.tableMetaDataItems.filter(function (meta) { return meta.lookup.sequenceNumber == metadata.lookup.sequenceNumber + 1; }).forEach(function (meta) {
            meta.lookup.sequenceNumber--;
        });
        metadata.lookup.sequenceNumber++;
        this.refreshTables();
    };
    ManageLookups.prototype.save = function () {
        var _this = this;
        if (!(this.unitOfWorkObserver && this.unitOfWorkObserver.hasChanges())) {
            return;
        }
        var ids = [];
        var _loop_1 = function (property) {
            var id = Number(property);
            var change = this_1.tableMetaDataItems.filter(function (item) { return item.id == id; })[0];
            if (isNaN(id) || !change) {
                return "continue";
            }
            ids.push(change.id);
        };
        var this_1 = this;
        for (var property in this.unitOfWorkObserver.getChanges().lookupValues) {
            _loop_1(property);
        }
        var request = {
            tableMetadataIds: ids,
            persistLookupsRequest: { changes: this.unitOfWorkObserver.getChanges() }
        };
        this.lookupClientService.updateLookupsOrdering(request).then(function (response) {
            _this.notificationClient.show(_this.i18N.tr('successfully-saved-text') + "!", _this.i18N.tr('lookup-has-been-successfully-saved-text'), NotificationType.Success);
        }).catch(function (response) {
            _this.notificationClient.show(_this.i18N.tr('error-text') + "!", _this.i18N.tr('unknown-error-text') + ".", NotificationType.Error);
        });
    };
    __decorate([
        computedFrom(Reflection.getPropertyPath(function (x) { return x.tableMetaDataItems; })),
        __metadata("design:type", Number),
        __metadata("design:paramtypes", [])
    ], ManageLookups.prototype, "maxSequenceNumber", null);
    __decorate([
        computedFrom(Reflection.getPropertyPath(function (x) { return x.isSequenceSorting; }), Reflection.getPropertyPath(function (x) { return x.currentTableMetaData; }), Reflection.getPropertyPath(function (x) { return x.currentTableMetaData.lookup.sequenceNumber; })),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], ManageLookups.prototype, "isSavable", null);
    __decorate([
        computedFrom(Reflection.getPropertyPath(function (x) { return x._search; })),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], ManageLookups.prototype, "search", null);
    ManageLookups = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [LookupClientService, NotificationClientService, BindingEngine, I18N])
    ], ManageLookups);
    return ManageLookups;
}(NotifyPropertyChangedBase));
export { ManageLookups };
